__webpack_require__.p = "/NeuralSynth/";